<script>
import '../../../../utils/custome-validator'
import utils from '../../../../utils/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'ComplianceSettings',

  data () {
    return {
      complianceSettings: {},
      complianceSettingsSTR: null,
      iscomplianceEdited: false
    }
  },
  computed: {
    ...mapGetters(['complianceSettingsObj'])
  },
  created () {
    this.complianceSettings = this.complianceSettingsObj
    this.complianceSettingsSTR = JSON.stringify(this.complianceSettings, undefined, 4)
  },
  methods: {
    updateComplianceSettingsObj () {
      this.iscomplianceEdited = true
      if (utils.isJsonString(this.complianceSettingsSTR)) {
        this.complianceSettings = JSON.parse(this.complianceSettingsSTR)
        this.$store.commit('updateComplianceSettingsObj', this.complianceSettings)
      } else {
        if (this.complianceSettingsSTR.trim() === '') {
          this.$store.commit('updateComplianceSettingsObj', {})
        }
      }
    }
  }
}
</script>
<template>
  <div
    id="compliance-settings-section"
    class="card mb-4">
    <h5
      aria-controls="compliance-settings"
      aria-expanded="true"
      class="card-header collapsed cursor-pointer"
      data-target="#compliance-settings"
      data-toggle="collapse"
    >
      <span class="font-weight-bold">{{ $t("label.complianceSettings") }}</span>
      <span class="collapsible-arrow pull-right cursor-pointer" />
    </h5>
    <div
      id="compliance-settings"
      class="card-body collapse">
      <div class="mt-4">
        <textarea
          v-validate="{ validJson: true }"
          v-model="complianceSettingsSTR"
          :class="{ 'is-invalid': errors.has('complianceSettings') }"
          class="form-control"
          rows="10"
          cols="67"
          name="complianceSettings"
          placeholder=""
          @input="updateComplianceSettingsObj(errors.has('complianceSettings'))"
        />
        <span
          v-if="iscomplianceEdited && errors.has('complianceSettings')"
          class="invalid-feedback"
        >{{ errors.first("complianceSettings") }}
        </span>
      </div>
    </div>
  </div>
</template>
